export enum SSP_BANNER_FORMAT {
    '320x50' = 1,
    '300x250'= 2,
    '320x100'= 3,
    'excluded'  ,
}
export enum SSP_INTERSTITIAL_FORMAT {
    '320x480' =11,
    '480x320' =12,
    '0x0' = 13, // 320 x 480 & 480 x 320
    'excluded'   ,
}
export enum SSP_NATIVE_FORMAT {
    '0x0'       = 20,
    '1200x627 & 1200x628'  = 21,
    '300x300'   = 22,
    '400x400'   = 23,
}

export type SSP_FORMAT_TYPE = SSP_BANNER_FORMAT | SSP_INTERSTITIAL_FORMAT;
